var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16LiveStatCardRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#FB2C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16LiveStatCardRed);
export default __webpack_public_path__ + "static/media/kbv-v16-live-stat-card-red.ef6afc32d9eed32f24e8ed3b2f4914bb.svg";
export { ForwardRef as ReactComponent };